import { useFetchSubscriptionUsageOverTime } from "src/queries/hooks/accountSettings";
import { useFetchAdminSubscriptionUsageOverTime } from "src/queries/hooks/admin";
import { buildChartData, formatChartedRange, formatTermRange, limitToRecentMonths, sumSkillsAcrossMonths } from "./UsageOverTime.utils";

const useUsageOverTime = ({ accountId, isAccountContext, enabled }) => {
  const accountQuery = useFetchSubscriptionUsageOverTime({
    accountId,
    enabled: enabled && isAccountContext
  });
  const adminQuery = useFetchAdminSubscriptionUsageOverTime({
    accountId,
    enabled: enabled && !isAccountContext
  });

  const { data, isLoading, isError } = isAccountContext ? accountQuery : adminQuery;
  const months = data?.months ?? [];
  const chartedMonths = limitToRecentMonths(months);

  return {
    chartData: buildChartData(chartedMonths),
    // Quota-bar tooltip stays whole-term: sum over every month, not just the charted ones.
    // undefined until the response is in, so the quota-bar tooltip can tell "not loaded" from "no skills".
    skillsByChannel: data ? sumSkillsAcrossMonths(months) : undefined,
    // Header shows the charted window; falls back to the term dates when there is nothing to chart yet.
    termRange: formatChartedRange(chartedMonths) ?? formatTermRange(data?.termStartDate, data?.termEndDate),
    isLoading: enabled && isLoading,
    isError,
    isEmpty: !isLoading && !isError && months.length === 0
  };
};

export default useUsageOverTime;
